<template>
    <div class="box">
        <div class="field">
            <p class="title">Verify Email</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>
        <table>
            <tr>
                <td>
                    <p class="textlabel">Enter Password</p>
                </td>
                <td>
                    <input class="textfield" type="password" v-model="password" @keydown.enter="signup()"></input>
                </td>
            </tr>
        </table>
        <div class="field">
            <button type="button" v-on:click="signup()">Login</button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        krypto: ''
    },
	data() {
		return {
            password: '',
		}
	},
	methods: {
        signup() {
            api.postData(
                {
                    type:"verify",
                    data:{
                        pageid:PAGES.VERIFY_PAGE,
                        data:[
                            this.krypto,
                            this.password
                        ]
                    }
                }
            ).then((res) => {
                if(res.data.verified){
                    alert('Your account has been verified, you will now be redirected to the login page');
                    router.push('/0200');
                }else{
                    alert('Incorrect password, please try again');
                }
	        });
        }
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    white-space:nowrap;
    font-size:14px;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Verify.vue